const uuidRegex = /^[0-9a-f]{8}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{12}/i;

type DisplayIdProps = {
    id?: string | null;
    prefix?: string;
    suffix?: string;
};

/**
 *
 * This component is used to display an user frendly ID.
 * If the ID is an UUID, it will return null.
 */
export function DisplayId({ id, prefix, suffix }: DisplayIdProps) {
    if (id && uuidRegex.test(id)) {
        return null;
    }

    return (
        <>
            {prefix}
            {id}
            {suffix}
        </>
    );

    // return id;
}
